module.exports = __webpack_public_path__ + "img/loading.a6f431e2.svg";